import React, {useEffect, useState} from "react";
import {DateObject} from "react-multi-date-picker";
import usePrice from "../../hooks/usePrice";
import useBookable from "../../hooks/useBookable";
import SpotPopup from "../SpotPopup/SpotPopup";
import Button from "../Button/Button";
import Popup from "../Popup/Popup";

const BookingPrice = (props) => {

  const {
    className,
    name,
    formData,
    save,
    hasError,
    error,
    wizard,
  } = props

  const {
    countBookingPriceTypeNegotiate,
    formatPrice,
    formatPercent,
    getBookingDates,
    getBookable,
  } = usePrice()
  const booking = formData.model
  const bookable = getBookable(booking)
  const [showPopupSpot, setShowPopupSpot] = useState([])
  const {isSpotGroup, isStand} = useBookable()
  const countTypeNegotiate = countBookingPriceTypeNegotiate(booking, bookable)
  const days = getBookingDates(booking).length
  const [showOfferPopupStand, setShowOfferPopupStand] = useState(false)
  const [showOfferPopupSpotGroup, setShowOfferPopupSpotGroup] = useState(false)

  useEffect(() => {
    if (formData.isChanged === false) {
      initiate()
    }
  }, [formData.isChanged])

  /**
   *
   */
  const initiate = () => {
    // const date = new DateObject()
    // Check if negotiate_offers needs initialization:
    // - doesn't exist, is null, or is empty but should have items
    if (
      !(name in formData.model) ||
      formData.model.negotiate_offers_new === null ||
      (formData.model.negotiate_offers_new.length === 0 && countTypeNegotiate > 0)
    ) {
      formData.model.negotiate_offers_new = []
      for (let i = 0; i < countTypeNegotiate; i++) {
        formData.model.negotiate_offers_new.push({
          spot_id: null,
          stand_id: null,
          value: 0, //total amount for all booking dates for this spot/stand
          type: 'negotiate',
        })
      }
    }

    save(false)
  }

  const onChangeNegotiateTypeSpot = (e, index, spot) => {
    if (!formData.model.negotiate_offers_new?.[index]) return
    formData.model.negotiate_offers_new[index].type = e.target.value
    formData.model.negotiate_offers_new[index].spot_id = spot.id
    save()
  }

  const onChangeInputSpot = (e, index, spot) => {
    if (!formData.model.negotiate_offers_new?.[index]) return
    formData.model.negotiate_offers_new[index].value = e.target.value
    formData.model.negotiate_offers_new[index].spot_id = spot.id
    save()
  }

  const onChangeNegotiateTypeStand = (e, index, stand) => {
    if (!formData.model.negotiate_offers_new?.[index]) return
    formData.model.negotiate_offers_new[index].type = e.target.value
    formData.model.negotiate_offers_new[index].stand_id = stand.id
    save()
  }

  const onChangeInputStand = (e, index, stand) => {
    if (!formData.model.negotiate_offers_new?.[index]) return
    formData.model.negotiate_offers_new[index].value = e.target.value
    formData.model.negotiate_offers_new[index].stand_id = stand.id
    save()
  }


  const getNegotiateType = (index) => {
    if (formData.model.negotiate_offers_new && formData.model.negotiate_offers_new[index]) {
      return formData.model.negotiate_offers_new[index].type
    } else {
      return 'negotiate'
    }
  }

  const getNegotiateValue = (index) => {
    if (formData.model.negotiate_offers_new && formData.model.negotiate_offers_new[index]) {
      return formData.model.negotiate_offers_new[index].value
    } else {
      return 0
    }
  }

  /**
   * Get all spots with price type 'negotiate'
   *
   * @returns {*}
   */
  const getNegotiateSpots = () => {
    if (!formData.model.spots || !Array.isArray(formData.model.spots)) {
      return []
    }
    return formData.model.spots.filter(spot => spot.price?.type === 'negotiate')
  }

  /**
   * Get the stand with type 'negotiate'
   *
   * @returns {*}
   */
  const getNegotiateStand = () => {
    if (formData.model.stand?.price?.type === 'negotiate') {
      return [formData.model.stand]
    } else {
      return []
    }
  }

  /**
   * Get offers array from booking.negotiate_offers for specific spot
   *
   * @param spot
   * @returns {*[]|*}
   */
  const getOffersBySpot = (spot) => {
    if (formData.model.negotiate_offers && Array.isArray(formData.model.negotiate_offers)) {
      return formData.model.negotiate_offers.filter(offer => offer.spot_id === spot.id)
    }
    return []
  }

  /**
   * Get offers array from booking.negotiate_offers for specific stand
   *
   * @param stand
   * @returns {*[]|*}
   */
  const getOffersByStand = (stand) => {
    if (formData.model.negotiate_offers && Array.isArray(formData.model.negotiate_offers)) {
      return formData.model.negotiate_offers.filter(offer => offer.stand_id === stand.id)
    }
    return []
  }

  const NewOfferForm = ({index, hasOffers, onChange}) => {
    return (
      <div className="add-offer">
        <h4>Nieuw bod doen:</h4>
        {hasError && <span className="error"> - {error}</span>}
        <div className="row price">
          <div className="label">
            <p>Type prijs:</p>
          </div>
          <div className="">
            <select
              name="type"
              id=""
              onChange={onChange}
              value={getNegotiateType(index)}
            >
              {booking.direction === 'receiving' ?
                <>
                  <option value="positive">Verdien:</option>
                  <option value="negative">Betaal:</option>
                </>
                :
                <>
                  <option value="positive">Betaal:</option>
                  <option value="negative">Verdien:</option>
                </>
              }
              <option value="relative">Omzet: Prijs hangt af van de omzet (percentage)</option>
              {hasOffers
                ? <option value="negotiate">Laatste bod handhaven</option>
                : <option value="negotiate">Later kiezen/nog niet overeengekomen (n.o.t.k.)</option>
              }
            </select>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={className + 'booking-price '}>
      {countTypeNegotiate > 0 ?
        <>
          {isSpotGroup(bookable) &&
            <>
              <h3>Deze boekingsaanvraag
                heeft {countTypeNegotiate} {(countTypeNegotiate === 1) ? 'standplaats' : 'standplaatsen'} met een
                N.O.T.K
                prijs:</h3>
              <p>Doe direct een bod
                voor {(countTypeNegotiate === 1) ? 'de onderstaande standplaats' : 'alle onderstaande standplaatsen'},
                of doe dit later. Deze boekingsaanvraag kan pas afgerond worden als alle standplaatsen met N.O.T.K
                prijzen minimaal 1 bod gedaan is.</p>
              <p>Deze boeking is voor {(days) === 1 ? days + ' dag' : days + ' dagen'}.</p>

              <div className="spot-group-spots">
                {getNegotiateSpots().map((spot, index) => {
                  let hasOffers = false
                  return (
                    <div key={index} className="spot-price">
                      <div className="negotiate">


                        <div className="row">
                          <div className="col col-label">
                            {spot.spot_cluster
                              ? <div className="label">Onderhandelen over prijs
                                standplaats: {spot.spot_cluster.label}: {spot.label}</div>
                              : <div className="label">Onderhandelen over prijs standplaats: {spot.label}</div>
                            }
                          </div>
                          <div className="col col-button">
                            <div
                              className="popup-button"
                              onClick={() => setShowPopupSpot({...showPopupSpot, [index]: true})}
                            >
                              <Button
                                label="Standplaats Info"
                                size="s"
                                color="grey"
                              />
                            </div>
                            <SpotPopup
                              spot={spot}
                              iteration={index}
                              setShowPopupSpot={setShowPopupSpot}
                              showPopupSpot={showPopupSpot}
                            />
                          </div>
                        </div>


                        {getOffersBySpot(spot).map((negotiateOffer, i) => {
                          hasOffers = true
                          return (
                            <div
                              className={(i === 0) ? "negotiate-offers final" : "negotiate-offers"}
                              key={i}
                            >
                              {(i === 0) ? "Laatste bod:" : ""} Datum
                              bod: {new DateObject(negotiateOffer.date).toString()}
                              ,&nbsp;
                              Type:&nbsp;
                              {booking.direction === 'receiving' && negotiateOffer.price?.type === 'positive' && 'Verdien'}
                              {booking.direction === 'requesting' && negotiateOffer.price?.type === 'positive' && 'Betaal'}
                              {booking.direction === 'receiving' && negotiateOffer.price?.type === 'negative' && 'Betaal'}
                              {booking.direction === 'requesting' && negotiateOffer.price?.type === 'negative' && 'Verdien'}
                              {negotiateOffer.price?.type === 'relative' && 'Omzet'}
                              {negotiateOffer.price?.type === 'negotiate' && 'Onderhandelen'}
                              ,&nbsp;
                              <strong>
                                {negotiateOffer.price?.type === 'relative'
                                  ? <>{formatPercent(negotiateOffer.price?.default)}</>
                                  : <>{formatPrice(negotiateOffer.price?.default)}</>
                                }
                              </strong>
                            </div>
                          )
                        })}

                        <NewOfferForm
                          index={index}
                          onChange={e => onChangeNegotiateTypeSpot(e, index, spot)}
                          hasOffers={hasOffers}
                        />

                        {getNegotiateType(index) !== 'negotiate' &&
                          <div className="row">
                            <input
                              placeholder=""
                              type="number"
                              min="0"
                              step="1"
                              value={getNegotiateValue(index)}
                              onChange={e => onChangeInputSpot(e, index, spot)}
                            /> <p> {(getNegotiateType(index) === 'relative') ? 'procent' : 'ex. BTW, in euro'}
                            {
                              (getNegotiateType(index) === 'relative')
                                ? <></>
                                :
                                <>, per dag.
                                  {formData.model.date_ranges.length > 1 &&
                                    <>&nbsp;Dus
                                      voor {(days) === 1 ? days + ' dag' : days + ' dagen'}: {formatPrice(getNegotiateValue(index) * formData.model.date_ranges.length)}</>
                                  }
                                </>
                            }
                          </p>
                          </div>
                        }
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          }


          {isStand(bookable) &&
            <>
              <h3>De stand/truck/act in deze boekingsaanvraag heeft een N.O.T.K prijs:</h3>
              <p>Doe direct een bod of doe dit later. Deze boekingsaanvraag kan pas geaccepteerd worden er minimaal 1
                bod gedaan is.</p>
              <p>Deze boeking is voor {(days) === 1 ? days + ' dag' : days + ' dagen'}.</p>

              <div className="stands">
                {getNegotiateStand().map((stand, index) => {
                  let hasOffers = false
                  return (
                    <div key={index} className="stand-price">
                      <div className="negotiate">

                        <div className="row">
                          <div className="col col-label">
                            <div className="label">Onderhandelen over prijs stand: {stand.label}</div>
                          </div>
                        </div>


                        {getOffersByStand(stand).map((negotiateOffer, i) => {
                          hasOffers = true
                          return (
                            <div
                              className={(i === 0) ? "negotiate-offers final" : "negotiate-offers"}
                              key={i}
                            >
                              {(i === 0) ? "Laatste bod:" : ""} Datum
                              bod: {new DateObject(negotiateOffer.date).toString()}
                              ,&nbsp;
                              Type:&nbsp;
                              {booking.direction === 'receiving' && negotiateOffer.price?.type === 'positive' && 'Verdien'}
                              {booking.direction === 'requesting' && negotiateOffer.price?.type === 'positive' && 'Betaal'}
                              {booking.direction === 'receiving' && negotiateOffer.price?.type === 'negative' && 'Betaal'}
                              {booking.direction === 'requesting' && negotiateOffer.price?.type === 'negative' && 'Verdien'}
                              {negotiateOffer.price?.type === 'relative' && 'Omzet'}
                              {negotiateOffer.price?.type === 'negotiate' && 'Onderhandelen'}
                              ,&nbsp;
                              <strong>
                                {negotiateOffer.price?.type === 'relative'
                                  ? <>{formatPercent(negotiateOffer.price?.default)}</>
                                  : <>{formatPrice(negotiateOffer.price?.default)}</>
                                }
                              </strong>
                            </div>
                          )
                        })}

                        <NewOfferForm
                          index={index}
                          hasOffers={hasOffers}
                          onChange={e => onChangeNegotiateTypeStand(e, index, stand)}
                        />

                        {getNegotiateType(index) !== 'negotiate' &&
                          <div className="row">
                            <input
                              placeholder=""
                              type="number"
                              min="0"
                              step="1"
                              value={getNegotiateValue(index)}
                              onChange={e => onChangeInputStand(e, index, stand)}
                            /> <p> {(getNegotiateType(index) === 'relative') ? 'procent' : 'ex. BTW, in euro'}
                            {
                              (getNegotiateType(index) === 'relative')
                                ? <></>
                                :
                                <>, per dag.
                                  {formData.model.date_ranges.length > 1 &&
                                    <>&nbsp;Dus
                                      voor {(days) === 1 ? days + ' dag' : days + ' dagen'}: {formatPrice(getNegotiateValue(index) * formData.model.date_ranges.length)}</>
                                  }
                                </>
                            }
                          </p>
                          </div>
                        }
                      </div>
                    </div>
                  )
                })}
              </div>
            </>
          }
        </>
        :
        <>
          Er zijn geen onderhandelbare prijzen voor deze boeking
        </>
      }
    </div>
  )
}

export default BookingPrice
